import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import WhatsAppButton from "../../components/feature/WhatsAppButton";
import HeroSection from "./components/HeroSection";
import OpenCompanySection from "./components/OpenCompanySection";
import ServicesSection from "./components/ServicesSection";
import DifferentialsSection from "./components/DifferentialsSection";
import SupportSection from "./components/SupportSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <OpenCompanySection />
        <ServicesSection />
        <DifferentialsSection />
        <SupportSection />
        <TestimonialsSection />
        <FaqSection />
        <ContactSection />
        <CtaSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
